import { endpointDeclaration } from '@moojo/endpoints'
import { ShopIcp } from '@moojo/shop-icp'
import { z } from 'zod'

export const FinalizeCalibrationRequest = z.object({
  calibrationId: z.string(),
  defaultize: z.boolean(),
  basics: z
    .object({
      agentId: z.string(),
      appId: z.string(),
      shopUrl: z.string(),
      shopIcp: ShopIcp.optional(),
      materialsToProduce: z
        .union([z.literal('icpCriterion'), z.literal('icpQuestions'), z.literal('plaidQuery')])
        .array(),
    })
    .optional(),
  extractedProduct: z
    .object({
      calibrationUrl: z.string(),
      productName: z.string(),
      productUrl: z.string(),
      productImageUrl: z.string(),
    })
    .optional(),
  hostingSite: z
    .object({
      calibrationUrl: z.string(),
      screenshotUrl: z.string(),
    })
    .optional(),
})
export type FinalizeCalibrationRequest = z.infer<typeof FinalizeCalibrationRequest>

export const FinalizeCalibrationResponse = z.record(z.string(), z.never())
export type FinalizeCalibrationResponse = z.infer<typeof FinalizeCalibrationResponse>

export const finalizeCalibrationDeclaration = endpointDeclaration(
  FinalizeCalibrationRequest,
  FinalizeCalibrationResponse,
)
